import * as React from 'react';
import './PayRemainingSuccess.scss';
import InterfaceIcon from '../../../../../assets/interface';
import PrintIcon from '../../../../../assets/print';
import exportIcon from '../../../../../assets/export';
import downarrowIcon from '../../../../../assets/downArrow';
import { Redirect, withRouter, RouteComponentProps } from 'react-router-dom';
import {
  IFiltersInvoice,
  IInvoiceCreditPayment
} from 'src/services/invoice/InvoiceService';

class PayRemainingSuccess extends React.Component<any> {
  public Backinvoices = () => {
    this.props.history.push('/invoices');
  };
  public render() {
    return (
      <div className="apply-credit">
        <img className="interface-icon" src={InterfaceIcon} />
        <div className="success-msg">
          Successfully applied credit & made the payment!
        </div>
        <button className="back-btn" onClick={this.Backinvoices}>
          Back to Open Invoices
        </button>
        <div className="transaction-details">
          <div className="details-label">Transaction Details</div>
          <div className="d-flex amount-details">
            <span className="credit-used-amount">
              <b>$5,000.00 </b>of credit used
            </span>
            <span className="line-gap">|</span>
            <span className="credit-used-amount">
              <b>$2,000.00</b> paid using E-check
            </span>
            <span className="line-gap">|</span>
            <span className="credit-used-amount text-decor">
              <b>250 Original Invoices</b>
            </span>
          </div>
          <div className="d-flex justify-content-center">
            <div className="print">
              <img className="image-icon" src={PrintIcon} />
              <span className="Print-label">Print</span>
            </div>
            <div className="export">
              <img className="image-icon" src={exportIcon} />
              <span className="Print-label">Export</span>
              <img className="down-arrow" src={downarrowIcon} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(PayRemainingSuccess);
